/**
 * GF Budget Slider — range-bar alignment fix
 *
 * Problem: GF's JS sets #gfSliderRange as a simple 0–100 % percentage of the
 * container, but WebKit positions the thumb centre at:
 *   half_thumb  +  (value / range) × (containerWidth − thumbWidth)
 * This creates a fixed 30 px over/under-shoot at each end that is not a fixed
 * percentage (it varies with container width), so no CSS translateX can fix it.
 *
 * Solution: after every slider input event, we recompute left/width directly
 * from the slider values using the same formula WebKit uses, overriding GF's
 * simpler calculation.
 */

/** Must match CSS ::-webkit-slider-thumb width (includes inner-edge bleed room). */
const THUMB_MIN_W = 32;
const THUMB_MAX_W = 32;

function initBudgetSliderFix() {
  const wrap      = document.getElementById('gfSliderWrap');
  const bar       = document.getElementById('gfSliderRange');
  const minSlider = document.getElementById('gfMinSlider');
  const maxSlider = document.getElementById('gfMaxSlider');

  if (!wrap || !bar || !minSlider || !maxSlider) return;

  function adjust() {
    const W = wrap.offsetWidth;
    if (!W) return;

    const min  = parseFloat(minSlider.min)   || 0;
    const max  = parseFloat(minSlider.max)   || 1;
    const vMin = parseFloat(minSlider.value) || 0;
    const vMax = parseFloat(maxSlider.value) || max;
    const range = max - min || 1;

    const halfMin = THUMB_MIN_W / 2;
    const halfMax = THUMB_MAX_W / 2;
    const trackMin = W - THUMB_MIN_W;
    const trackMax = W - THUMB_MAX_W;

    // Pixel positions of each thumb centre (WebKit's actual rendering positions)
    const pxMin = halfMin + ((vMin - min) / range) * trackMin;
    const pxMax = halfMax + ((vMax - min) / range) * trackMax;

    // Convert back to percentages of the container
    const leftPct  = (pxMin / W) * 100;
    const widthPct = ((pxMax - pxMin) / W) * 100;

    // Override GF's inline styles; disconnect observer while we write to
    // prevent the mutation from triggering adjust() again.
    obs.disconnect();
    bar.style.left  = leftPct  + '%';
    bar.style.width = Math.max(0, widthPct) + '%';
    obs.observe(bar, { attributes: true, attributeFilter: ['style'] });
  }

  // React whenever GF (or anything else) rewrites the bar styles
  const obs = new MutationObserver(adjust);
  obs.observe(bar, { attributes: true, attributeFilter: ['style'] });

  // Also react to direct slider interaction
  minSlider.addEventListener('input', adjust);
  maxSlider.addEventListener('input', adjust);

  // Run once after GF has finished its own initial render
  // (gform_post_render fires after GF JS finishes; fall back to rAF)
  if (window.jQuery) {
    jQuery(document).on('gform_post_render', adjust);
  }
  requestAnimationFrame(adjust);
}

// GF renders forms asynchronously, so we wait for DOMContentLoaded and
// also listen for the GF ready event in case the form loads later.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBudgetSliderFix);
} else {
  initBudgetSliderFix();
}

if (window.jQuery) {
  jQuery(document).on('gform_post_render', initBudgetSliderFix);
}
